import React from "react";
import Logo from "../assets/images/banner.jpg";
import {Col, Row} from "react-bootstrap";

const Banner = () => {
    return (
        <div
            className="main-banner wow fadeIn"
            id="top"
            data-wow-duration="1s"
            data-wow-delay="0.5s"
        >
            <div className="container">
                <Row>
                    <Col md={6}>
                        <div className="align-self-center p-3">
                            <div
                                className="left-content header-text wow fadeInLeft"
                                data-wow-duration="1s"
                                data-wow-delay="1s"
                            >
                                <h6>Innovation. Automation. Growth.</h6>
                                <h2>
                                    Turn bold ideas into digital products with{" "}
                                    State-of-art <span>AI-powered Web</span> &amp;{" "}
                                    <span>Mobile Apps</span> your customers will love.
                                </h2>
                            </div>
                        </div>
                    </Col>
                    <Col md={6}>
                        <div>
                            <div className="right-image wow fadeInRight">
                                <img src={Logo} alt="team meeting"/>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    );
};
export default Banner;
